(function($){
    $('.show-fullscreen-menu').on('click', function(e){
        e.preventDefault();
        $('.fullscreen-menu').slideDown(500);
    })
    $('.fullscreen-menu .close').on('click', function(e){
        e.preventDefault();
        $('.fullscreen-menu').slideUp(500);
    })
    $('.fullscreen-menu [href="#contact"]').on('click', function(e){
        $('.fullscreen-menu').slideUp(500);
    })
})(jQuery)